<template>
  <div class="log-out-button">
    <button
      :class="buttonClass"
      class="log-out-button__btn btn btn-accent-1"
      @click="logout">
      <slot>
        Log out
      </slot>
    </button>
  </div>
</template>

<script>
import { WebAccountResource } from "spiritweb.packages.web-account";

export default {
  name: "LogoutButton",
  props: {
    buttonClass: {
      type: String,
      default: "btn btn-accent-6",
    },
    redirectUrl: {
      type: String,
      default: "/",
    },
  },
  methods: {
    logout () {
      // TODO: Shouldn't need to pass a redirect url
      WebAccountResource.logout( this.redirectUrl )
        .then( () => {
          window.location = this.redirectUrl;
        } );
    },
  },
};
</script>

<style lang="less" scoped>
.log-out-button__btn {
  min-width: 110px;
}
</style>
